import { ShotBlockedAttribute } from '@collector/sportsapi-client-legacy'

import { DetailBaseConfigAttributes } from '../../../../composables/useSportOptions'

export const techniqueOfShotDetailsAttributes: DetailBaseConfigAttributes<ShotBlockedAttribute>['attributes'] =
  [
    {
      attributeId: ShotBlockedAttribute.LeftFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotBlockedAttribute.Normal,
          ShotBlockedAttribute.FirstTouch,
          ShotBlockedAttribute.Volley,
          ShotBlockedAttribute.BicycleKick,
          ShotBlockedAttribute.FreeKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotBlockedAttribute.Chip,
      isActive: (attributes) => {
        const validAttributes = [
          ShotBlockedAttribute.Normal,
          ShotBlockedAttribute.FirstTouch,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
    {
      attributeId: ShotBlockedAttribute.RightFoot,
      isActive: (attributes) => {
        const validAttributes = [
          ShotBlockedAttribute.Normal,
          ShotBlockedAttribute.FirstTouch,
          ShotBlockedAttribute.Volley,
          ShotBlockedAttribute.BicycleKick,
          ShotBlockedAttribute.FreeKick,
        ]

        return attributes.some((attribute) =>
          validAttributes.includes(attribute),
        )
      },
    },
  ]
